import React from 'react'
import styles from './header_.module.css'
import getStringsBasedLang from '../../strings/get_strings'
export default function BtnLogin(props) {

    return (
        <button className={styles.btn} onClick={props.onClickHandler}>{getStringsBasedLang("general_logInToAccount")}</button>
    )
}